import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.reduce";
export default function getSectionsAsMap(containerSections) {
  if (Array.isArray(containerSections)) {
    return containerSections.reduce(function (allSections, section) {
      if (section.id) {
        allSections[section.id] = section;
      }

      return allSections;
    }, {});
  }

  return {};
}